import type { FunctionComponent, PropsWithChildren } from "react";

const SidebarContent: FunctionComponent<PropsWithChildren> = ({ children }) => (
	<div className="grow overflow-auto p-7">{children}</div>
);
export default SidebarContent;